<div class="login-container mat-typography large-viewport">
  <div class="login-logo">
    <img src="assets/images/transend-logo-wide.svg" alt="Logo" class="logo-image" />
  </div>

  <mat-card class="login-card">
    <h2 class="login-title">Login</h2>

    <p class="login-desc">Enter your username and password</p>

    @if (errorMessage.length > 0) {
      <p class="error-message">
        {{ errorMessage }}
      </p>
    }

    <form class="login-form" [formGroup]="loginForm" (ngSubmit)="onSubmit()">
      <div class="form-field">
        <mat-form-field appearance="outline" hideRequiredMarker floatLabel="always">
          <mat-label>Username or Email</mat-label>
          <input matInput formControlName="username" required placeholder="Enter username or email"/>
          <mat-error>
            @if (loginForm.get('username')?.hasError('required')) {
              Username or Email is required.
            }
          </mat-error>
        </mat-form-field>
      </div>

      <div class="form-field">
        <mat-form-field appearance="outline" hideRequiredMarker floatLabel="always">
          <mat-label>Password</mat-label>
          <input
            matInput
            [type]="hidePassword ? 'password' : 'text'"
            formControlName="password"
            required
            />

          <!-- Eye icon button -->
          <button
            mat-icon-button
            matSuffix
            type="button"
            (click)="hidePassword = !hidePassword"
            [attr.aria-label]="hidePassword ? 'Show password' : 'Hide password'"
            [attr.aria-pressed]="!hidePassword"
            >
            <mat-icon>{{ hidePassword ? 'visibility' : 'visibility_off' }}</mat-icon>
          </button>

          <mat-error>
            @if (loginForm.get('password')?.hasError('required')) {
              Password is required.
            }
          </mat-error>
        </mat-form-field>

        <div class="forgot-links">
          <a class="link" [routerLink]="['/forgot-password']">Forgot Password</a>
          <a class="link" [routerLink]="['/recover-username']">Forgot User ID</a>
        </div>
      </div>

      <div class="action-buttons">
        <button type="submit" disableRipple [disabled]="isSubmitting || !loginForm.valid">Login</button>
      </div>
    </form>
  </mat-card>

  <div class="register-section">
    <p class="register-text">If you haven't registered yet, please sign up below.</p>
    <button mat-flat-button [routerLink]="['/register']">Register New Account</button>
  </div>

  <div class="footer">
    <p>Need help? Call (833) 378-3841 or email support&commat;transendfinancial.com</p>
    <p>Monday – Friday: 9 AM – 8 PM EST</p>

    <div class="footer-links">
      <a href="https://www.transendfinancial.com/terms-of-service" target="_blank" class="footer-link">Terms of
      Service</a>
      <span class="footer-separator">|</span>
      <a href="https://www.transendfinancial.com/privacy-policy" target="_blank" class="footer-link">Privacy Policy</a>
    </div>
  </div>
</div>

<!-- For small devices -->
<div class="login-container mat-typography small-viewport">
  <div class="login-logo">
    <img src="assets/images/transend-logo-wide.svg" alt="Logo" class="logo-image" />
  </div>

  <h2>Login</h2>

  <p>Enter your username and password</p>

  @if (errorMessage.length > 0) {
    <p class="error-message">
      {{ errorMessage }}
    </p>
  }

  <form class="login-form" [formGroup]="loginForm" (ngSubmit)="onSubmit()">
    <div class="form-field">
      <mat-form-field appearance="outline" hideRequiredMarker floatLabel="always">
        <mat-label>Username</mat-label>
        <input matInput formControlName="username" required />
        <mat-error>
          @if (loginForm.get('username')?.hasError('required')) {
            Username is required.
          }
        </mat-error>
      </mat-form-field>
    </div>

    <div class="form-field">
      <mat-form-field appearance="outline" hideRequiredMarker floatLabel="always">
        <mat-label>Password</mat-label>
        <input
          matInput
          [type]="hidePassword ? 'password' : 'text'"
          formControlName="password"
          required
          />

        <!-- Same eye icon -->
        <button
          mat-icon-button
          matSuffix
          type="button"
          (click)="hidePassword = !hidePassword"
          [attr.aria-label]="hidePassword ? 'Show password' : 'Hide password'"
          [attr.aria-pressed]="!hidePassword"
          >
          <mat-icon>{{ hidePassword ? 'visibility' : 'visibility_off' }}</mat-icon>
        </button>

        <mat-error>
          @if (loginForm.get('password')?.hasError('required')) {
            Password is required.
          }
        </mat-error>
      </mat-form-field>

      <a class="link" [routerLink]="['/forgot-password']">Forgot Password</a>
      <a class="link" [routerLink]="['/recover-username']">Forgot User ID</a>

    </div>

    <div class="action-buttons">
      <button type="submit" disableRipple [disabled]="isSubmitting || !loginForm.valid">Login</button>

      <div class="register-section">
        <p class="register-text">If you haven't registered yet, please sign up below.</p>
        <button mat-flat-button [routerLink]="['/register']">Register New Account</button>
      </div>
    </div>
  </form>

  <div class="footer">
    <p>Need help? Call (833) 378-3841 or email support&commat;transendfinancial.com</p>
    <p>Monday – Friday: 9 AM – 8 PM EST</p>

    <div class="footer-links">
      <a href="https://www.transendfinancial.com/terms-of-service" target="_blank" class="footer-link">Terms of
      Service</a>
      <span class="footer-separator">|</span>
      <a href="https://www.transendfinancial.com/privacy-policy" target="_blank" class="footer-link">Privacy Policy</a>
    </div>
  </div>
</div>
